import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { DatePicker } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CREATE_jwel } from "../Config/Config";
import Header from "../Header";
import SidebarDrawer from "../SidebarDrawer";
import styles from "./PurchasePlans.module.css";

const sections = [
  "Commodity Wise Purchase",
  "Product Wise Purchase",
  "Dealer Wise Purchase",
  "HSN Wise Purchase",
  "Brand Wise Purchase",
  "Tax Wise Purchase",
];

const PurchasePlans = () => {
  const [expanded, setExpanded] = useState([]);
  const [open, setOpen] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [commodityData, setCommodityData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [dealerData, setDealerData] = useState([]);
  const [hsnData, setHsnData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [taxData, setTaxData] = useState([]);
  // const [imagesData, setImagesData] = useState([]);
  // const [userArea, setUserArea] = useState();
  // const [userName, setUserName] = useState();
  // const [singleImage, setSingleImage] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);

  const imageUrls = localStorage.getItem("images").split(",");
  const imagesData = imageUrls;
  const userArea = localStorage.getItem("city");
  const userName = localStorage.getItem("user");
  const singleImage = localStorage.getItem("singleImage");
  const tenantName = localStorage.getItem("tenantName");

  const toggleDrawer = () => {
    setOpen(false);
  };

  const commodityAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=PURCHINVOICE_MAST&where=INVDATE>='${dayjs(
          fromDate,
        ).format(
          "MM/DD/YYYY",
        )}' AND INVDATE<='${dayjs(toDate).format("MM/DD/YYYY")}'`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;
      if (!Array.isArray(data) || data.length === 0) {
        setCommodityData([]);
        return;
      }

      // 👉 Grouping
      const grouped = Object.values(
        data.reduce((acc, item) => {
          const type = item.PType || "UNKNOWN";

          if (!acc[type]) {
            acc[type] = {
              PTYPE: type,
              TOTQTY: 0,
              NETAMT: 0,
            };
          }

          const qty = Number(item.TOTQTY || 0);
          const netAmt = Number(item.netamt || 0);

          acc[type].TOTQTY += qty;
          acc[type].NETAMT += netAmt;

          return acc;
        }, {}),
      );

      setCommodityData(grouped);

      // if (Array.isArray(data) && data.length > 0) {
      //   setCommodityData(data);
      // } else {
      //   setCommodityData([]);
      // }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const productAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetProductWisePurchase?startDate=${dayjs(
          fromDate,
        ).format("MM/DD/YYYY")}&endDate=${dayjs(toDate).format(
          "MM/DD/YYYY",
        )}&hid=0`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setProductData(data);
      } else {
        setProductData([]);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const dealerAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDLRWisePurchase?startDate=${dayjs(
          fromDate,
        ).format("MM/DD/YYYY")}&endDate=${dayjs(toDate).format(
          "MM/DD/YYYY",
        )}&hid=0`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setDealerData(data);
      } else {
        setDealerData([]);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const hsnAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetHNSWisePurchase?startDate=${dayjs(
          fromDate,
        ).format("MM/DD/YYYY")}&endDate=${dayjs(toDate).format(
          "MM/DD/YYYY",
        )}&hid=0`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setHsnData(data);
      } else {
        setHsnData([]);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const brandAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetBrandWisePurchase?startDate=${dayjs(
          fromDate,
        ).format("MM/DD/YYYY")}&endDate=${dayjs(toDate).format(
          "MM/DD/YYYY",
        )}&hid=0`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setBrandData(data);
      } else {
        setBrandData([]);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const taxAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetTaxWisePurchase?startDate=${dayjs(
          fromDate,
        ).format("MM/DD/YYYY")}&endDate=${dayjs(toDate).format(
          "MM/DD/YYYY",
        )}&hid=0`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setTaxData(data);
      } else {
        setTaxData([]);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  // const userAPI = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=FIRM_CONFIGURE`,
  //       {
  //         headers: {
  //           tenantName: tenantName,
  //         },
  //       }
  //     );

  //     const data = response.data;

  //     if (Array.isArray(data) && data.length > 0) {
  //       const imageUrls = data[0]?.EPASS1.split(",");
  //       setImagesData(imageUrls);
  //       setUserName(data[0]?.FIRMNAME);
  //       setUserArea(data[0]?.CITY);
  //       setSingleImage(data[0]?.EPASS2);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching estimation count:", error);
  //   }
  // };

  useEffect(() => {
    commodityAPI();
    productAPI();
    dealerAPI();
    hsnAPI();
    brandAPI();
    taxAPI();
    // userAPI();
  }, [fromDate, toDate]);

  const handleExpandAll = () => {
    setExpanded("all");
    commodityAPI();
    productAPI();
    dealerAPI();
    hsnAPI();
    brandAPI();
    taxAPI();
  };

  const handleCollapseAll = () => {
    setExpanded(null);
  };

  const handleChange = (panel) => {
    setExpanded((prev) => (prev === panel ? null : panel));
  };

  useEffect(() => {
    if (imagesData.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % imagesData.length);
      }, 1500);
      return () => clearInterval(interval);
    }
  }, [imagesData]);

  return (
    <div>
      <Header setOpen={setOpen} />
      <SidebarDrawer
        open={open}
        toggleDrawer={toggleDrawer}
        singleImage={singleImage}
        userArea={userArea}
        userName={userName}
      />
      <div className={styles.carouselContainer}>
        <div
          className={styles.carouselSlider}
          style={{
            transform: `translateX(-${currentIndex * 33.33}%)`,
            width: `${imagesData.length * 100}%`,
          }}
        >
          {imagesData.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`img-${index}`}
              className={styles.carouselImage}
            />
          ))}
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <h3 className={styles.heading}>Purchase Plan</h3>
          <div className={styles.buttonRow}>
            <button
              variant="outlined"
              type="default"
              className={styles.expandButton}
              onClick={handleExpandAll}
            >
              Expand All +
            </button>
            <button
              variant="outlined"
              type="default"
              className={styles.collapseButton}
              onClick={handleCollapseAll}
            >
              Collapse All -
            </button>
          </div>
        </div>
        <div className={styles.dateFilters}>
          <DatePicker
            value={fromDate}
            onChange={setFromDate}
            className={styles.datePicker}
            inputReadOnly
            format="DD-MMM-YYYY"
            maxDate={dayjs()}
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
          />
          <DatePicker
            value={toDate}
            onChange={setToDate}
            className={styles.datePicker1}
            inputReadOnly
            format="DD-MMM-YYYY"
            maxDate={dayjs()}
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
          />
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel1" || expanded === "all"}
            onChange={() => {
              handleChange("panel1");
              commodityAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                backgroundColor:
                  expanded === "panel1" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel1" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Commodity Wise Purchase
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel1" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel1" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              {commodityData.map((comm, index) => (
                <div
                  key={comm.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      {/* Code:{" "} */}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        {comm.PTYPE}
                      </span>
                    </span>
                    {/* <span
                      style={{
                        color: "#52bd91",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      #{index + 1}
                    </span> */}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      QTY:{" "}
                      <span
                        style={{
                          fontSize: "16px",
                          color: "#595a60",
                          fontWeight: "bold",
                        }}
                      >
                        {Number(comm.TOTQTY)?.toFixed(0)}
                      </span>
                    </span>
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {comm.NETAMT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel2" || expanded === "all"}
            onChange={() => {
              handleChange("panel2");
              productAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                backgroundColor:
                  expanded === "panel2" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel2" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Product Wise Purchase
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel2" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel2" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              {productData.map((product, index) => (
                <div
                  key={product.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      {/* Bill No:{" "} */}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        {product.ITEMNAME}
                      </span>
                    </span>
                    {/* <span
                              style={{
                                color: "#52bd91",
                                fontWeight: "bold",
                                fontSize: "20px",
                              }}
                            >
                              #{index + 1}
                            </span> */}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      QTY:{" "}
                      <span
                        style={{
                          color: "#595a60",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {Number(product.QTY)?.toFixed(0)}
                      </span>
                    </span>
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {product.AMOUNT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel3" || expanded === "all"}
            onChange={() => {
              handleChange("panel3");
              dealerAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                backgroundColor:
                  expanded === "panel3" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel3" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Dealer Wise Purchase
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel3" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel3" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              {dealerData.map((dealer, index) => (
                <div
                  key={dealer.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      {/* Bill No:{" "} */}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        {dealer.CUSTNAME}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      QTY:{" "}
                      <span
                        style={{
                          color: "#595a60",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {Number(dealer.QTY)?.toFixed(0)}
                      </span>
                    </span>
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {dealer.AMOUNT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel4" || expanded === "all"}
            onChange={() => {
              handleChange("panel4");
              hsnAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                backgroundColor:
                  expanded === "panel4" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel4" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              HSN Wise Purchase
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel4" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel4" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              {hsnData.map((hsn, index) => (
                <div
                  key={hsn.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      HSN Code:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        {hsn.HSNCODE}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      QTY:{" "}
                      <span
                        style={{
                          color: "#595a60",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {Number(hsn.QTY)?.toFixed(0)}
                      </span>
                    </span>
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {hsn.AMOUNT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel5" || expanded === "all"}
            onChange={() => {
              handleChange("panel5");
              brandAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                backgroundColor:
                  expanded === "panel5" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel5" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Brand Wise Purchase
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel5" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel5" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              {brandData.map((brand, index) => (
                <div
                  key={brand.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      {/* Brand Name:{" "} */}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        {brand.GROUPNAME}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      QTY:{" "}
                      <span
                        style={{
                          color: "#595a60",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {Number(brand.QTY)?.toFixed(0)}
                      </span>
                    </span>
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {brand.AMOUNT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel6" || expanded === "all"}
            onChange={() => {
              handleChange("panel6");
              taxAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                backgroundColor:
                  expanded === "panel6" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel6" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Tax Wise Purchase
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel6" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel6" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              {taxData.map((tax, index) => (
                <div
                  key={tax.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      GST(%):{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        {tax.GST?.toFixed(2) || 0}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      QTY:{" "}
                      <span
                        style={{
                          color: "#595a60",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {Number(tax.QTY)?.toFixed(0)}
                      </span>
                    </span>
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {tax.AMOUNT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default PurchasePlans;
